export * from "./PercentTag";
